// removed by extract-text-webpack-plugin
module.exports = {"main":"CreateSegment-main--2SinG","border":"CreateSegment-border--LxWEp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateSegment/CreateSegment.scss
// module id = nvBr
// module chunks = 4